import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseAbstractPage, SelectLanguageComponent } from '@incust-mobile/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome-page',
  templateUrl: 'welcome.page.html',
  styleUrls: ['welcome.page.scss'],
  standalone: true,
  imports: [IonicModule, TranslatePipe, SelectLanguageComponent]
})
export class WelcomePage extends BaseAbstractPage {
  constructor() {
    super();
  }

  async getStarted() {
    await this.router.navigate(['/home']);
  }
}
